const statusEnums = {
    completed: 'COMPLETED',
    inprogress: 'INPROGRESS',
};

const localkeys = {
    switchprompt: '__prompted_switch'
}

export {
    statusEnums,
    localkeys
}